export default __webpack_public_path__ + "static/media/7CE3855C-C6A4-462B-A342-D208621B9183.9922f037.jpg";